import {Component, Input} from '@angular/core';

@Component({
	selector: 'app-chatbot-animation',
	standalone: true,
	template: `
		<div
			class="container"
			[class.paused]="paused"
		>
			<div class="glow"></div>
			<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle class="outer-ring" cx="50" cy="50" r="38" stroke="hsla(190,90%,60%,0.2)" stroke-width="0.5" stroke-dasharray="4 4"/>
				<circle class="inner-ring" cx="50" cy="50" r="24" stroke="hsla(190,90%,60%,0.1)" stroke-width="0.5" stroke-dasharray="2 6"/>

				<circle class="sat1" cx="50" cy="12" r="1.5" fill="hsl(190,90%,60%)"/>
				<circle class="sat2" cx="83" cy="69" r="1" fill="hsl(190,90%,60%)"/>
				<circle class="sat3" cx="20" cy="75" r="1.2" fill="hsl(190,90%,60%)"/>

				@for (bit of bits; track $index) {
					<rect
						class="bit"
						[attr.x]="bit.x"
						[attr.y]="bit.y"
						width="2.5"
						height="2.5"
						rx="0.5"
						fill="white"
						[style.animation-delay]="bit.delay"
					/>
				}

				<circle cx="50" cy="50" r="12" fill="url(#glass-gradient)" stroke="hsla(0,0%,100%,0.1)" stroke-width="0.5"/>

				<line class="line1" x1="50" y1="38" x2="50" y2="14" stroke="hsla(190,90%,60%,0.15)" stroke-width="0.3"/>
				<line class="line2" x1="60" y1="56" x2="82" y2="68" stroke="hsla(190,90%,60%,0.15)" stroke-width="0.3"/>
				<line class="line3" x1="40" y1="58" x2="21" y2="74" stroke="hsla(190,90%,60%,0.15)" stroke-width="0.3"/>

				<defs>
					<radialGradient id="glass-gradient" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(50 50) rotate(90) scale(12)">
						<stop stop-color="white" stop-opacity="0.1"/>
						<stop offset="1" stop-color="white" stop-opacity="0"/>
					</radialGradient>
				</defs>
			</svg>
		</div>
	`,
	styles: [`
		:host { display: block; }
		.container { position: relative; width: 256px; height: 256px; display: flex; align-items: center; justify-content: center; cursor: pointer; }
		.glow { position: absolute; inset: 0; border-radius: 9999px; filter: blur(40px); background: hsl(190, 90%, 60%); animation: glow-pulse 2s cubic-bezier(0.2, 0, 0, 1) infinite; }
		svg { width: 100%; height: 100%; overflow: visible; }

		.outer-ring { animation: spin 20s linear infinite; transform-origin: 50px 50px; }
		.inner-ring { animation: spin-reverse 15s linear infinite; transform-origin: 50px 50px; }

		.sat1 { animation: pulse-sat1 2s cubic-bezier(0.2,0,0,1) infinite; }
		.sat2 { animation: pulse-sat2 2s cubic-bezier(0.2,0,0,1) infinite 0.7s; }
		.sat3 { animation: pulse-sat3 2s cubic-bezier(0.2,0,0,1) infinite 1.3s; }

		.bit { animation: pulse-bit 2s cubic-bezier(0.2,0,0,1) infinite; }

		.line1 { animation: pulse-line 2s cubic-bezier(0.2,0,0,1) infinite; }
		.line2 { animation: pulse-line 2s cubic-bezier(0.2,0,0,1) infinite 0.7s; }
		.line3 { animation: pulse-line 2s cubic-bezier(0.2,0,0,1) infinite 1.3s; }

		.paused .glow,
		.paused .outer-ring,
		.paused .inner-ring,
		.paused .sat1, .paused .sat2, .paused .sat3,
		.paused .bit,
		.paused .line1, .paused .line2, .paused .line3 {
			animation-play-state: paused;
		}

		@keyframes glow-pulse {
			0%, 100% { transform: scale(1); opacity: 0.15; }
			50% { transform: scale(1.2); opacity: 0.3; }
		}
		@keyframes spin { to { transform: rotate(360deg); } }
		@keyframes spin-reverse { to { transform: rotate(-360deg); } }
		@keyframes pulse-sat1 {
			0%, 100% { opacity: 0.5; r: 1.5; }
			50% { opacity: 1; r: 2.25; }
		}
		@keyframes pulse-sat2 {
			0%, 100% { opacity: 0.3; r: 1; }
			50% { opacity: 0.8; r: 1.8; }
		}
		@keyframes pulse-sat3 {
			0%, 100% { opacity: 0.4; r: 1.2; }
			50% { opacity: 0.9; r: 1.68; }
		}
		@keyframes pulse-bit {
			0%, 100% { opacity: 0.2; }
			50% { opacity: 1; }
		}
		@keyframes pulse-line {
			0%, 100% { opacity: 0.1; }
			50% { opacity: 0.3; }
		}
	`]
})
export class ChatbotIllustrationComponent {
	@Input() paused: boolean = false;
	//hovered = false;

	bits = Array.from({ length: 9 }, (_, i) => ({
		x: 44 + (i % 3) * 4,
		y: 44 + Math.floor(i / 3) * 4,
		delay: `${i * 0.1}s`,
	}));
}
